import axios from './axios';

let baseUrl = '';
const users = {};

const init = function(url) {
    // use init to set the baseUrl
    baseUrl = url;

    return users;
};

users.getUsers = function () {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + 'getUsers').then(function (res) {
            let data = res.data;

            resolve(data);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

users.getUser = function (userId) {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + 'getUser/' + userId).then(function (res) {
            let data = res.data;

            resolve(data);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

users.getCreatedTrims = function (userId) {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + 'getCreatedTrims/' + userId).then(function (res) {
            let data = res.data;

            resolve(data);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

users.edit = function (userData) {
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + 'edit', userData).then(function (res) {
            let { error, data } = res.data;

            if (error) {
                reject(error)
            }
            else {
                resolve(data);
            }

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

users.delete = function (userId) {
    return new Promise((resolve, reject) => {
        axios.delete(baseUrl + 'delete/' + userId).then(function (res) {
            let { error, data } = res.data;

            if (error) {
                reject(error)
            }
            else {
                resolve(data);
            }

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

export default init;